import React from "react";
import { AnimatedToggle } from "@components/animatedHeight";
import { UnitNumber } from "./addressParts/unitNumber";
import { StreetNumber } from "./addressParts/streetNumber";
import { Street } from "./addressParts/street";
import { Suburb } from "./addressParts/suburb";
import { State } from "./addressParts/state";
import { PostCode } from "./addressParts/postCode";
import { PaperWidthRow } from "@components/paper/paper";
import { PaddingLeftCol } from "@components/leftGrid";

export const ExpandedAddressDetails = (props) => {
  const { isOpen } = props;

  return (
    <AnimatedToggle show={isOpen}>
      <PaperWidthRow>
        <PaddingLeftCol xs={12} sm={12} md={3} xl={3} lg={3}>
          <UnitNumber />
        </PaddingLeftCol>
        <PaddingLeftCol xs={12} sm={12} md={3} xl={3} lg={3}>
          <StreetNumber />
        </PaddingLeftCol>
        <PaddingLeftCol xs={12} sm={12} md={6} xl={6} lg={6}>
          <Street />
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow>
        <PaddingLeftCol xs={12} sm={12} md={6} xl={6} lg={6}>
          <Suburb />
        </PaddingLeftCol>
        <PaddingLeftCol xs={12} sm={12} md={3} xl={3} lg={3}>
          <State />
        </PaddingLeftCol>
        <PaddingLeftCol xs={12} sm={12} md={3} xl={3} lg={3}>
          <PostCode />
        </PaddingLeftCol>
      </PaperWidthRow>
    </AnimatedToggle>
  );
};